import type { GridFilterOperator } from '@mui/x-data-grid-pro';

export const getFilteredOperators = (
  operators: GridFilterOperator[],
  allowedOperators: string[],
) => operators.filter(({ value }) => allowedOperators.includes(value));
